const defaultRoutes: Record<string, string> = {
  admin: '/dashboard',
  manage_staff: '/staffs',
  manage_res: '/residents',
  manage_act: '/activities',
  default: '/estates',
}

export default defaultRoutes
